import {
  ID,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildGoalTasksTree } from '@griply/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type Options = {
  goals: { id: ID; name: string }[];
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  showEmptyGroups?: boolean;
  hideNoGoalGroup?: boolean;
  hideNewTaskRow?: boolean;
  rootId?: ID;
};

export const useGoalTree = ({
  goals,
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  showEmptyGroups,
  hideNoGoalGroup,
  hideNewTaskRow,
  rootId,
}: Options) => {
  const { t } = useTranslation();
  const inboxLabel = t('general.sections.goals.other.title');

  return useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildGoalTasksTree({
        goals,
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        showEmptyGroups,
        hideNoGoalGroup,
        hideNewTaskRow,
        rootId,
        inboxLabel,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
      }),
    [
      customOrder,
      goals,
      sortingMode,
      tasks,
      today,
      weekStartsOn,
      showEmptyGroups,
      hideNoGoalGroup,
      hideNewTaskRow,
      rootId,
      inboxLabel,
    ],
  );
};
